import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import user from './modules/user'
import { getParseStorge, setStorgeItem } from '@/utils/auth'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user
  },
  getters,
  state: {
    userInfo: getParseStorge('webUserInfo'), // 用户信息
    showHeader: true, // 显示header
    showUserHeader: true, // 显示个人中心用户信息
    activeTab: '0',  //个人中心当前tab
    showAddInteres: getParseStorge('webShowAddInteres')  //是否展示过添加兴趣标签
  },
  mutations: {
    SET_USER_INFO: (state, data) => {
      state.userInfo = data
      setStorgeItem('webUserInfo', data)
    },
    SET_HEADER: (state, data) => {
      state.showHeader = data
    },
    SET_USER_HEADER: (state, data) => {
      state.showUserHeader = data
    },
    SET_ACTIVE_TAB: (state, data) => {
      state.activeTab = data
    },
    SET_SHOW_ADD_INTRERS: (state, data) => {
      state.showAddInteres = data
      setStorgeItem('webShowAddInteres', data)
    },
  },
  actions: {
    setUserInfo({ commit }, data) {
      commit('SET_USER_INFO', data)
    },
    setHeader({ commit }, data) {
      commit('SET_HEADER', data)
    },
    setShowUserHeader({commit}, data) {
      commit('SET_USER_HEADER', data)
    },
    setActiveTab({commit}, data) {
      commit('SET_ACTIVE_TAB', data)
    },
    setShowAddInteres({commit}, data) {
      commit('SET_SHOW_ADD_INTRERS', data)
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js